
import { ref, PropType } from "vue";
import Team from '@/shared/teams/team';

export default {
  name: "StandingsRow",
  props: {
    team: {
      type: Object as PropType<Team>,
    }
  },
  setup(props: any) {
    const statuses = {
      0: "Out",
      1: "In Danger",
      2: "In For Now",
      3: "Safe",
    };

    const teamClass = ref<string>("");
    let teamName = "";

    if (props.team.name.length > 23 && screen.width < process.env.VUE_APP_WIDTH_PHONE_PORTRAIT) {
      teamName = props.team.name.substring(0,20) + '...';
    }


    if (props.team.status === 1) teamClass.value = "team--danger";
    else if (props.team.status === 4) teamClass.value = "team--out";

    return { statuses, teamClass, teamName };
  },
};
